import { useQsFilters } from "@dash/filters";

import { BlikCheckFilters, blikCheckFiltersSerializer } from "@megaron/megarax-uri";

export type BlikChecksFiltersType = BlikCheckFilters;

export const useBlikChecksFilters = () => {
  const defaultFilters: BlikChecksFiltersType = {
    page: 0,
    status: undefined,
    searchTerm: undefined,
  };

  const { filters, setFilters } = useQsFilters(blikCheckFiltersSerializer, defaultFilters);

  const setFilter =
    <K extends keyof BlikChecksFiltersType>(key: K) =>
    (value: BlikChecksFiltersType[K]) =>
      setFilters({ ...filters, [key]: value });

  return { filters, setFilter, setFilters, defaultFilters };
};
